/* The manufacturer logos in the footer ticker. Kept apart from site.js
   because it is a list of imports that nothing else needs, and the
   footer is the only place it is read.

   A logo whose lettering sits inside a coloured shape carries a `tone`,
   so the footer sets it in grey rather than as a flat white silhouette
   that would swallow the lettering; contact.css explains the two. */

import ABB from '../media/images/footer-logos/abb.png';
import Legrand from '../media/images/footer-logos/legrand.png';
import Leviton from '../media/images/footer-logos/leviton.png';
import PassAndSeymour from '../media/images/footer-logos/pass_and_seymour.png';
import SavantPower from '../media/images/footer-logos/savant-power.png';
import SchneiderElectric from '../media/images/footer-logos/schneider_electric.png';
import Siemens from '../media/images/footer-logos/Siemens.png';
import SquareD from '../media/images/footer-logos/square-d.png';

const partners = [
    { src: ABB,               alt: 'ABB',                href: 'https://global.abb/' },
    { src: SchneiderElectric, alt: 'Schneider Electric',  href: 'https://www.se.com/' },
    { src: Siemens,           alt: 'Siemens',             href: 'https://www.siemens.com/' },
    { src: SquareD,           alt: 'Square D',            href: 'https://www.se.com/us/en/brands/square-d/', tone: 'keep' },
    { src: Legrand,           alt: 'Legrand',             href: 'https://www.legrand.us/' },
    { src: Leviton,           alt: 'Leviton',             href: 'https://www.leviton.com/', tone: 'flip' },
    { src: PassAndSeymour,    alt: 'Pass & Seymour',      href: 'https://www.legrand.us/pass-and-seymour' },
    { src: SavantPower,       alt: 'Savant Power',        href: 'https://www.savant.com/savant-power' }
];

export default partners;
